const PROMO = {
  tls450VariantId: 44893364256927,
  usmVariantId: 44893360062623,
  giftBundleVariantId: 62840309448863
};

let promotionSyncTimer;
let promotionIsSyncing = false;

function isCartPage() {
  return /(^|\/)cart\/?$/.test(window.location.pathname);
}

function addPromotionStyles() {
  if (document.querySelector('[data-tls450-promo-styles]')) return;

  const style = document.createElement('style');

  style.setAttribute('data-tls450-promo-styles', '');
  style.textContent = `
    .tls450-gift-badge {
      display: inline-block;
      width: fit-content;
      margin: 0 0 7px;
      padding: 4px 9px;
      border-radius: 999px;
      background: #176b78;
      color: #ffffff;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: .06em;
      line-height: 1;
      text-transform: uppercase;
    }

    .tls450-gift-line .cart__remove,
    .tls450-gift-line [data-remove],
    .tls450-gift-line a[href*="/cart/change"] {
    display: none !important;
    }

    .tls450-gift-line .quantity-input {
    opacity: 0.45;
    pointer-events: none;
    cursor: not-allowed;
    }

    .tls450-gift-line .quantity-input input {
    background: #f3f5f6 !important;
    color: #8a98a6 !important;
    }

    .tls450-gift-line a[href*="/products/"] {
      cursor: default !important;
      pointer-events: none !important;
      text-decoration: none !important;
    }

    .tls450-gift-line .cart__item-title,
    .tls450-gift-line .cart-item__title,
    .tls450-gift-line .cart-item__product-title,
    .tls450-gift-line a[href*="/products/"] {
    color: #8a98a6 !important;
    }
  `;

  document.head.appendChild(style);
}

function getLineItemElement(lineKey) {
  return Array.from(document.querySelectorAll('[data-key]')).find(
    (element) => element.dataset.key === lineKey
  );
}


async function syncTls450Gift() {
  if (!isCartPage() || promotionIsSyncing) return;

  promotionIsSyncing = true;

  try {
    const cart = await fetch('/cart.js').then((response) => response.json());

    const tls450Quantity = cart.items
      .filter((item) => item.variant_id === PROMO.tls450VariantId)
      .reduce((total, item) => total + item.quantity, 0);

    const moduleQuantity = cart.items
      .filter((item) => item.variant_id === PROMO.usmVariantId)
      .reduce((total, item) => total + item.quantity, 0);

    // One gift bundle for every complete TLS-450 + module pair.
    const requiredGiftBundleQuantity = Math.min(
      tls450Quantity,
      moduleQuantity
    );

    const giftBundleLine = cart.items.find(
      (item) =>
        item.variant_id === PROMO.giftBundleVariantId &&
        item.properties?._promotion === 'TLS450_GIFT_BUNDLE'
    );

    const currentGiftBundleQuantity = giftBundleLine
      ? giftBundleLine.quantity
      : 0;

    // Cart already has the correct number of gift bundles.
    if (currentGiftBundleQuantity === requiredGiftBundleQuantity) return;

    let response;

    if (giftBundleLine) {
      // Update or remove only the promotional gift bundle line.
      response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftBundleLine.key,
          quantity: requiredGiftBundleQuantity
        })
      });
    } else if (requiredGiftBundleQuantity > 0) {
      // Add the required number of gift bundles.
      response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: PROMO.giftBundleVariantId,
            quantity: requiredGiftBundleQuantity,
            properties: {
              _promotion: 'TLS450_GIFT_BUNDLE',
              _gift_label: 'Regalo: paquete de 3 sensores LS-750'
            }
          }]
        })
      });
    }

    if (response && !response.ok) {
      throw new Error('No se pudo actualizar el paquete de regalo.');
    }

    window.location.reload();
  } catch (error) {
    console.error('Error en promoción TLS-450:', error);
  } finally {
    promotionIsSyncing = false;
  }
}

function schedulePromotionSync() {
  clearTimeout(promotionSyncTimer);
  promotionSyncTimer = setTimeout(syncTls450Gift, 100);
}

addPromotionStyles();
schedulePromotionSync();

// Detect cart-page updates. This only rechecks eligibility;
// it does not alter any non-promotional cart line.
if (isCartPage()) {
  const cartArea = document.querySelector('#main');

  if (cartArea) {
    new MutationObserver(schedulePromotionSync).observe(cartArea, {
      childList: true,
      subtree: true
    });
  }
}